<template>
  <div class="station-list" :class="darkMode ? 'dark' : ''">
    <div class="stationsheader f8">
      <span>{{ $t("Stations") }} </span>
      <div v-if="multipleStationsSelected() && noMixedSelected()" class="settings"
        @click="openMultipleStationsSettings()">
        Edit Selected &nbsp;<UIIcon name="settings" />
      </div>

      <div v-else-if="multipleStationsSelected() && !noMixedSelected()" class="settings multiSelectedError"
        data-tooltip="Cannot edit maintained and operational stations at the same time"
        @click="showMultiSelectedError()"
      >
        Edit Selected &nbsp;<UIIcon name="settings" />
      </div>

      <p class="pl4">
        <input class="checkbox" type="checkbox"  @click="isAllSelected() ? deselectAllStations() : selectAllStations()" :checked="isAllSelected()"/>
      </p>
    </div>
    <div class="experiencestationgroup" v-for="experience in experiences" :key="experience.id">
      <template v-if="getExperienceStations(experience).length">
        <h1 :style="{ width: getExperienceStations(experience).length * 13 + 'rem' }" class="experiencetitle f9">{{ experience.title }}</h1>
        <div class="stationcards">
          <StationCard v-for="station in getExperienceStations (experience)"
          :darkMode="darkMode" :isNetworkAvailable="isNetworkAvailable" :key="station.id"
          :station="station" @checkedStation="checkedStation" :checked="isChecked(station.id)" v-on="$listeners" v-bind="$attrs" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import StationCard from './card/StationCard';
import UIIcon from '@/core/shared/components/ui/UIIcon';

@Component({
  props: {
    experiences: {
      type: Array,
      required: true,
    },
    stations: {
      type: Array,
      required: true,
    },
    isNetworkAvailable: {
      type: Boolean,
      required: true,
    },
    darkMode: {
      type: Boolean,
      required: false,
    },
    // checkedStations: {
    //   type: Array,
    //   required: false,
    //   default: () => [],
    // },
  },
  data: () => ({
    checkedStations: [],
  }),
  inheritAttrs: false,
  components: {
    StationCard,
    UIIcon,
  },
})
export default class StationList extends Vue {
  getExperienceStations (experience) {
    return this.stations.filter(station => {
      return station.experience.id === experience.id;
    });
  }

  noMixedSelected () {
    let allTrue = true;
    let allFalse = true;
    this.checkedStations.forEach(stationId => {
      const index = this.stations.map(station => station.id).indexOf(stationId);
      allTrue = allTrue && this.stations[index].maintenanceModeEnabled;
      allFalse = allFalse && !this.stations[index].maintenanceModeEnabled;
    });

    return (allTrue || allFalse);
  }

  selectAllStations () {
    this.checkedStations = [];
    this.stations.forEach(station => this.checkedStations.push(station.id));
  }

  deselectAllStations () {
    this.checkedStations = [];
  }

  isAllSelected () {
    return this.checkedStations.length === this.stations.length;
  }

  isChecked (stationId) {
    return this.checkedStations.indexOf(stationId) > -1;
  }

  multipleStationsSelected () {
    return this.checkedStations.length > 1;
  }

  selectedStationsNames () {
    const returnedString = this.stations.filter(station => { return this.checkedStations.includes(station.id); }).map(s => '\'' + s.title + '\'')
      .join(', ').replace(/, ([^,]*)$/, ' and $1');
    return 'Edit ' + returnedString;
  }

  openMultipleStationsSettings () {
    this.$store.commit('setOverviewScrollPosition');
    this.$router.push({ name: 'multiple-stations-settings', params: { stationsId: this.checkedStations, stationsNames: this.selectedStationsNames() } });
  }

  showMultiSelectedError () {
    this.$store.commit('setFlash', {
      message: this.$t('Cannot edit maintained and operational stations at the same time'),
      type: 'info',
    });
  }

  checkedStation (stationId) {
    const index = this.checkedStations.indexOf(stationId);
    index === -1 ? this.checkedStations.push(stationId) : this.checkedStations.splice(index, 1);
  }
}
</script>

<style scoped lang="postcss">
@import 'core/shared/styles';

/* custom tooltip */
[data-tooltip]:before {
  /* needed - do not touch */
  content: attr(data-tooltip);
  position: absolute;
  opacity: 0;
  pointer-events: none;

  /* customizable */
  transition: all 0.15s ease;
  padding: 10px;
  color: #182942;
  border-radius: 7px;
  box-shadow: 2px 2px 1px silver;
}

[data-tooltip]:hover:before {
  /* needed - do not touch */
  opacity: 1;

  /* customizable */
  background: rgb(255, 255, 255);
  margin-top: 10px;
  margin-left: 20px;
  z-index: 3000;
}

.station-list {
  & .stationsheader {
    background-color: var(--colorWhite);
    margin: 0;
    padding: var(--spacingXS) var(--spacingSm);
    box-shadow: var(--shadowMd);

    & .settings {
      float: right;
      cursor: pointer;
      margin: 1rem 0;
      color: red;

      & svg {
        fill: var(--colorGeyser);
        width: 1.5rem;
        height: 1.5rem;
        vertical-align: top;
        margin-left: 2px;
      }
    }
    & .multiSelectedError
    {
      color: #d5d8df;
    }

  }

  & .experiencestationgroup {
    position: relative;
    background-color: var(--colorGeyser);

    &:nth-child(2n) {
      background-color: var(--colorCasper);
    }

    & .experiencetitle {
      position: absolute;
      padding: 0 var(--spacingSm);
      line-height: 1.6;
      bottom: 0;
      left: 2rem;
      transform: rotate(-90deg);
      transform-origin: bottom left;
      text-align: right;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 2rem;
      margin: 0;
    }

    & .stationcards {
      margin-left: 2rem;
      flex: 1 0 auto;
    }
  }
}
.station-list.dark .stationsheader {
  background-color: var(--darkModeColorDarkBackground);
  color: var(--darkModeColorText);
  border-right: solid white 1px;
}
.station-list.dark .experiencestationgroup .experiencetitle  {
  background-color: var(--darkModeColorDarkBackground);
  color: var(--darkModeColorText);
}

</style>
